import React from 'react';
import { AlertCircle, AlertTriangle } from 'lucide-react';

export default function DetailsView({ interactions, medications, filters }) {
  const groups = [
    { key: 'severe', label: 'Graves', bg: '#FEF2F2', icon: <AlertTriangle size={16} className="text-danger" /> },
    { key: 'moderate', label: 'Moderadas', bg: '#FFF7ED', icon: <AlertTriangle size={16} className="text-warning" /> },
    { key: 'mild', label: 'Leves', bg: '#FFFBEB', icon: <AlertCircle size={16} className="text-warning" /> }
  ];

  return (
    <div className="bg-white rounded shadow-sm p-4 h-100 overflow-auto">
      <h6>Detalles y Recomendaciones</h6>
      {groups.map(g => {
        const list = interactions.filter(i => i.severity === g.key);
        if (!filters[`show${g.key.charAt(0).toUpperCase() + g.key.slice(1)}`] || list.length === 0) return null;
        return (
          <div key={g.key} className="mt-3">
            <div className="fw-bold mb-2" style={{
              color: g.key === 'severe' ? '#B91C1C' : g.key === 'moderate' ? '#C2410C' : '#CA8A04'
            }}>
              {g.label}
            </div>
            {list.map((i, idx) => {
              const s = medications.find(m => m.id === i.source) || {};
              const t = medications.find(m => m.id === i.target) || {};
              return (
                <div key={idx} className="rounded mb-2" style={{ background: g.bg, padding: '.75rem' }}>
                  <div className="d-flex align-items-center mb-1">
                    {g.icon}
                    <span className="ms-2 fw-semibold">{s.name} + {t.name}</span>
                  </div>
                  <div className="small text-muted mb-1">{i.description}</div>
                  <div className="bg-white rounded border p-2 small">
                    <strong>Recomendación:</strong> Monitorice y ajuste dosis según necesidad.
                  </div>
                </div>
              );
            })}
          </div>
        );
      })}

      {/* Referencias */}
      <div className="mt-6">
        <h4 className="text-md font-medium text-gray-900 mb-3">Referencias</h4>
        <div className="bg-light-50 rounded-lg space-y-2">
          <div className="p-3 m-2 border border-gray-200 rounded text-sm" style={{ backgroundColor: '#f9fafb'}}>
            <div className="font-medium">DrugBank – Base de datos de interacciones</div>
            <div className="text-gray-600 mt-1">Fuente primaria para interacciones medicamentosas</div>
          </div>
          <div className="p-3 m-2 border border-gray-200 rounded text-sm" style={{ backgroundColor: '#f9fafb'}}>
            <div className="font-medium">Lexicomp – Severidad y recomendaciones clínicas</div>
            <div className="text-gray-600 mt-1">Referencia para severidad y recomendaciones clínicas</div>
          </div>
        </div>
      </div>
    </div>
  );
}
